import { render, staticRenderFns } from "./EditorAttachmentTray.vue?vue&type=template&id=a8b69c68&scoped=true&"
import script from "./EditorAttachmentTray.vue?vue&type=script&lang=js&"
export * from "./EditorAttachmentTray.vue?vue&type=script&lang=js&"
import style0 from "./EditorAttachmentTray.vue?vue&type=style&index=0&id=a8b69c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b69c68",
  null
  
)

export default component.exports